/**
 * Store documentation module.
 *
 * @module store/documentation/module
 * @author Dilan Useche <dilan8810@gmail.com>
 * */

import state from './documentation.state';
import mutations from './documentation.mutations';
import actions from './documentation.actions';
import getters from './documentation.getters';

/**
 * export default
 *  @type {VuexModule}
 * */
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
